import { render, staticRenderFns } from "./BaseCountryFlagPhoneInput.vue?vue&type=template&id=ab51ff12"
import script from "./BaseCountryFlagPhoneInput.vue?vue&type=script&lang=js"
export * from "./BaseCountryFlagPhoneInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports